<div class="flex flex-wrap gap-3 p-3" style="max-width: 100%; overflow: hidden">
  @if (cookieRole === 'SYSADMIN' || cookieRole === 'ACCESOS') {
    <!-- Importa MatButtonModule y MatMenuModule si aún no lo has hecho -->
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="getBusinessCount(1)">
        <mat-icon mat-icon-button>trending_up</mat-icon>Activas
      </button>
      <button mat-menu-item (click)="getBusinessCount(2)">
        <mat-icon mat-icon-button>trending_down</mat-icon>Suspendidas
      </button>
    </mat-menu>

    <mat-card
      class="p-card flex-1 w-full md:w-6 lg:w-4 mx-2"
      style="background-color: #333; color: #fff">
      <mat-card-content
        class="flex flex-column justify-content-between mx-3 my-4 h-full">
        <!-- Botones encima de la tarjeta -->
        <div class="flex align-items-center">
          <button mat-fab color="accent" [matMenuTriggerFor]="menu">
            <mat-icon>shopping_bag</mat-icon>
          </button>
          <div class="ml-3">
            <div class="font-bold" style="font-size: 1.15rem">
              Empresas {{ businessStateLabel() }}: {{ TotalBusiness() }}
            </div>
            <div class="mt-1">Total {{ TotalBusinessNoFilters() }}</div>
          </div>
        </div>
        <div class="w-full pl-5 mt-4 font-bold" style="font-size: 2rem">
          Empresas
        </div>
      </mat-card-content>
    </mat-card>
  }

  <!-- Repetir el card anterior con el mismo contenido -->
  <mat-card class="p-card flex-1 w-full md:w-6 lg:w-4 mx-2">
    <mat-card-content
      class="flex flex-column justify-content-between mx-3 my-4 h-full">
      <div class="flex align-items-center">
        <button mat-fab color="accent">
          <mat-icon>person</mat-icon>
        </button>
        <div class="ml-3">
          <div class="font-bold" style="font-size: 1.15rem">Total</div>
          <div class="mt-1">Usuarios registrados</div>
        </div>
      </div>
      <div class="w-full pl-5 mt-4 font-bold" style="font-size: 2rem">
        {{ TotalUsers() }}
      </div>

      @if (cookieRole !== 'SYSADMIN' && cookieRole !== 'ACCESOS') {
        <div class="flex justify-content-left mt-4">
          <span>Usuarios con reservas activas </span>
          <span
            class="font-bold"
            style="font-size: 1.5rem; margin-left: 10px"
            >{{ TotalReservationsActive() }}</span
          >
        </div>
      }
    </mat-card-content>
  </mat-card>

  <mat-menu #menu2="matMenu">
    <button mat-menu-item (click)="getReservationsCount('lastWeek')">
      <mat-icon mat-icon-button>schedule</mat-icon>Última semana
    </button>
    <button mat-menu-item (click)="getReservationsCount('lastMonth')">
      <mat-icon mat-icon-button>schedule</mat-icon>Último mes
    </button>
    <button mat-menu-item (click)="getReservationsCount('lastThreeMonths')">
      <mat-icon mat-icon-button>schedule</mat-icon>Últimos 3 meses
    </button>
    <button mat-menu-item (click)="getReservationsCount('lastYear')">
      <mat-icon mat-icon-button>schedule</mat-icon>Último año
    </button>
  </mat-menu>

  <mat-card class="p-card flex-1 w-full md:w-6 lg:w-4 mx-2">
    <mat-card-content
      class="flex flex-column justify-content-between mx-3 my-4 h-full">
      <div class="flex align-items-center">
        <button mat-fab color="accent" [matMenuTriggerFor]="menu2">
          <mat-icon>history</mat-icon>
        </button>
        <div class="ml-3">
          <div class="font-bold" style="font-size: 1.15rem">Total</div>
          <div class="mt-1">{{ labelReservationsCount() }}</div>
        </div>
      </div>
      <div class="w-full pl-5 mt-4 font-bold" style="font-size: 2rem">
        {{ TotalReservations() }}
      </div>
    </mat-card-content>
  </mat-card>
</div>
<!-- CARDS -->
<div
  id="element-to-capture"
  class="col ms:col md:col-12 lg:p-grid lg:flex xl:p-grid xl:flex"
  style="max-width: 100%; overflow: hidden">
  <mat-card class="p-card p-col-12 p-md-6 p-lg-6 mx-2">
    <mat-card-header id="report-title" class="pb-3">
      <mat-card-title class="font-bold">Reporte de reservas</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="grid">
        @if (cookieRole === 'SYSADMIN' || cookieRole === 'ACCESOS') {
          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
            appearance="outline">
            <mat-label>Empresa</mat-label>
            <mat-select [(ngModel)]="businessId" [(value)]="selectValueCompani">
              <mat-option [value]="-1" (click)="ObtenerEdificios(-1)">
                Generales
              </mat-option>
              @for (buss of bussines; track buss) {
                <mat-option
                  [value]="buss.idBusiness"
                  (click)="ObtenerEdificios(buss.idBusiness!)">
                  {{ buss.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field
          class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
          appearance="outline">
          <mat-label>Edificio</mat-label>
          <mat-select [(ngModel)]="buildingId">
            @for (edificio of edificios; track edificio) {
              <mat-option
                [value]="edificio.buildingid"
                (click)="chargueFloorByBuilding(edificio.buildingid)">
                {{ edificio.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
          appearance="outline">
          <mat-label>Nivel</mat-label>
          <mat-select [(ngModel)]="floorId">
            @for (floor of floors; track floor) {
              <mat-option
                [value]="floor.floorid"
                (click)="selectFloor(floor.floorid)">
                {{ floor.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
          appearance="outline">
          <mat-label>Tipo de puesto</mat-label>
          <mat-select [(ngModel)]="workPlaceId">
            @for (puesto of puestos; track puesto) {
              <mat-option
                [value]="puesto.workplacetypeid"
                (click)="selectType(puesto.workplacetypeid)">
                {{ puesto.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
          appearance="outline">
          <mat-label>Rango de fechas</mat-label>
          <mat-select
            [(ngModel)]="filter"
            (selectionChange)="onRangeChange($event)">
            @for (range of rangeFilter(); track range) {
              <mat-option
                [value]="range.value"
                (click)="getReservationsGraphic()">
                {{ range.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="justify-content-center ms:justify-content-center md:flex md:align-items-center md:justify-content-center lg:flex lg:align-items-center lg:justify-content-center xl:flex xl:align-items-center xl:justify-content-center">
        <canvas
          id="reservations-canvas"
          class="h-15rem w-15rem sm:h-15rem sm:w-15rem md:h-30rem md:w-30rem lg:h-30rem lg:w-30rem xl: h-15rem xl: w-15rem"
          baseChart
          [data]="barChartData"
          [options]="barChartOptions"
          [type]="barChartType">
        </canvas>
        <div
          class="flex pt-3 pl-8 xl:pl-0 lg:pt-0 flex-column md:flex-row gap-3 justify-content-center md:justify-content-end mb-2 ms:justify-content-center dm:flex md:gap-3 md:justify-content-end md:flex-wrap md:mb-7 lg:flex lg:gap-3 lg:justify-content-end lg:flex-wrap mb-7 xl:flex xl:gap-3 xl:justify-content-end xl:flex-wrap xl:mb-7">
          <shared-button
            [icon]="'save_alt'"
            [typeBtn]="'button'"
            (click)="downloadExcel()"
            color="accent">
            Excel
          </shared-button>
          <shared-button
            [icon]="'save_alt'"
            [typeBtn]="'button'"
            (click)="downloadPDF()"
            color="accent">
            P D F
          </shared-button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card
    class="p-card p-col-12 p-md-6 p-lg-6 mx-2 my-4 md:my-0 xl:my-0 lg:my-0 ms:p-card ms:p-col-12 ms:p-md-6 ms:p-lg-6 ms:mx-2 ms:my-4 md:p-card md:p-col-12 md:p-md-6 md:p-lg-6 md:mx-2 lg:p-card lg:p-col-12 lg:p-md-6 lg:p-lg-6 lg:mx-2 xl:p-card xl:p-col-12 xl:p-md-6 xl:p-lg-6 xl:mx-2 md:my-4">
    <mat-card-header class="pb-3">
      <mat-card-title id="report" class="font-bold"
        >Horarios más ocupados</mat-card-title
      >
    </mat-card-header>
    <mat-card-content><app-heat-map /></mat-card-content>
  </mat-card>
</div>
<!-- REPORTE DE LUGARES MAS OCUPADOS -->
<div class="gap-3 p-3" style="max-width: 100%; overflow: hidden">
  <mat-card class="">
    <mat-card-header class="pb-3">
      <mat-card-title id="report" class="font-bold"
        >Reporte de lugares más ocupados</mat-card-title
      >
    </mat-card-header>
    <mat-card-content><app-heat-map-image /></mat-card-content>
  </mat-card>
</div>
